export default "__VITE_ASSET__3373e025__"